<template>
  <div class="home-post-title-container" v-if="isShow">
    <div class="title-txt" :class="[lang]">{{ $t('postTitleTxt') }}</div>
    <a-button class="post-title-btn" :class="[lang]" type="primary" @click="publishPost" :loading="btnLoading">{{ $t('postTitleBtnTxt') }}</a-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bus from '@/utils/bus';

export default {
  props: {
    isSales: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      postInfo: {},
      btnLoading: false,
    }
  },
  i18n: require("./posti18n"),
  computed: {
    ...mapState("setting", ["lang"]),
    isShow () {
      let pathSales = {
        '/sales/salesReps/home': true,
        '/sales/salesReps/campaign': true,
      }
      let pathHr = {
        '/hr/recruiter/home': true,
        '/hr/recruiter/campaign': true,
      }
      let path = pathSales
      if (!this.isSales) {
        path = pathHr
      }
      if (path[this.$route.path]) {
        // return true
        return this.postInfo.is_show
      }
      return false
    },
  },
  activated () {
    this.getPostTitleInfo();
  },
  methods: {
    getPostTitleInfo() {
      this.$axios(
        '/public/show_pop_title',
        {
          campaign_type: this.isSales ? 1 : 2
        },
        'post'
      ).then(res => {
        if (res.code == 200) {
          this.postInfo = (res.data && res.data.data) || {}
        }
      })
    },
    // 发布post
    publishPost () {
      this.btnLoading = true
      this.$axios(
        '/public/titlebar_post',
        {
          linkedin_id: this.postInfo.linkedin_id
        },
        'post'
      ).then(res => {
        this.btnLoading = false
        if (res.code == 200) {
          this.postInfo.is_show = false
          Bus.$emit('showPostSuccessModal');
          this.getUserInfo()
        }
      }).catch(() => {
        this.btnLoading = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.home-post-title-container {
  padding: 28px 30px 0;
  height: 64px;
  display: flex;
  justify-content: space-between;
  .title-txt {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    line-height: 36px;
  }
  .btn {
    padding: 0 14px;
    height: 36px;
    line-height: 34px;
    font-weight: bold;
    color: #fff;
  }
}
</style>
